import { forwardRef } from "react";
import { FieldError } from "react-hook-form";
import {
  Field,
  FormFieldStatus,
  Hint,
  Label,
  Option,
  Select,
} from "@gocardless/flux-react";
import { t, Trans } from "@lingui/macro";

import { MonthlyCollections } from "../consts";

import { getInputErrorStatus } from "src/utils/inputValidation";
import { FieldLevelError } from "src/common/api";

interface MonthlyCollectionDropdownProps {
  error?: FieldError;
  apiError?: FieldLevelError;
}

export const MonthlyCollectionsDropdown = forwardRef<
  HTMLSelectElement,
  MonthlyCollectionDropdownProps
>(({ error, apiError, ...field }, ref) => {
  const monthlyCollectionsOptions = Object.values(MonthlyCollections).map(
    (amount) => (
      <Option key={amount} value={amount} data-testid={amount}>
        {amount}
      </Option>
    )
  );

  return (
    <Field data-testid="monthly_collections">
      <Label htmlFor="monthly_collections">
        <Trans id="sign-up.form.monthly_collections.label">
          How many payments could we have helped you collect last month?
        </Trans>
      </Label>
      <Select
        ref={ref}
        id="monthly_collections"
        {...field}
        status={getInputErrorStatus(!!error)}
      >
        {[
          <Option key="default" value="">
            {t({
              id: "Please select",
              message: "Please select",
            })}
          </Option>,
          ...monthlyCollectionsOptions,
        ]}
      </Select>
      {error && (
        <Hint status={FormFieldStatus.Danger}>
          <Trans id="sign-up.form.monthly_collections.field-required-warning">
            Number of payments is required
          </Trans>
        </Hint>
      )}
      {apiError && (
        <Hint status={FormFieldStatus.Danger}>{apiError.message}</Hint>
      )}
    </Field>
  );
});
